import { render, staticRenderFns } from "./FavoritesTable.vue?vue&type=template&id=61b60309&scoped=true&"
import script from "./FavoritesTable.vue?vue&type=script&lang=js&"
export * from "./FavoritesTable.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesTable.vue?vue&type=style&index=0&id=61b60309&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b60309",
  null
  
)

export default component.exports